import BehaviorConfig from '@/models/app-config/behavior/behavior'
import Vue, { VueConstructor } from 'vue'
import CompletedDefaultCaption from './components/DefaultCaption.vue'

export interface SignUpCompletedPageParts {
  readonly caption: VueConstructor
}
type SignUpCompletedPagePartsGenerator = (behavior: BehaviorConfig) => SignUpCompletedPageParts

type DefaultCompletedPartsGenerator = (diff?: Partial<SignUpCompletedPageParts>) => SignUpCompletedPagePartsGenerator
export const defaultCompletedParts: DefaultCompletedPartsGenerator = (diff = {}) => behavior => ({
  caption: defaultCaptionWith(behavior.groupLabel),
  ...diff,
})
const defaultCaptionWith = (hostName: string) => Vue.extend({
  components: { CompletedDefaultCaption },
  template: `<completed-default-caption host-name="${hostName}" />`,
})

export const mycolorCompletedParts = defaultCompletedParts()

export const vilbCompletedParts = defaultCompletedParts({
  caption: defaultCaptionWith('美ラボ'),
})

export const fitowaCompletedParts = defaultCompletedParts({
  caption: defaultCaptionWith('FITOWA'),
})

export const loadingParts: SignUpCompletedPageParts = {
  caption: Vue.extend({ template: '<div></div>' }),
}
